const StorageService = {
  KEYS: {
    ACCESS_TOKEN: 'lerner.at'
  },

  setItem(key, data) {
    localStorage.setItem(key, data);
  },

  getItem(key) {
    return localStorage.getItem(key);
  },

  removeItem(key) {
    localStorage.removeItem(key);
  }
};

export default StorageService;